import EmployeeInfoContactInfoComponent from "../components/EmployeeInfoContactInfo";
import useEmployeeContactInfo from "../hooks/useEmployeeContactInfo";

function EmployeeInfoContactInfo(props) {
  const useEmployeeContactInfoProps = useEmployeeContactInfo();
  return <EmployeeInfoContactInfoComponent {...useEmployeeContactInfoProps} {...props} />;
}

export default EmployeeInfoContactInfo;
